import React from 'react';
import { SvgProps } from 'apps/sigma2-ui/src/components/svg/types';
import { toSvgColor } from 'apps/sigma2-ui/src/components/svg/types';

export const TableSortDirectionArrowAscGroup: React.FC<SvgProps> = (props) => {
  const fillColor = toSvgColor('currentColor', props);

  return (
    <g {...(props.group ?? {})}>
      <path
        d="M8.27311 13.2334C8.56087 13.2334 8.76563 13.0342 8.76563 12.7464L8.76563 5.45833L8.72136 4.27409L10.3815 6.09473L11.6432 7.33431C11.7262 7.42285 11.8591 7.46712 11.9919 7.46712C12.2686 7.46712 12.4678 7.25684 12.4678 6.98568C12.4678 6.85287 12.418 6.73666 12.3128 6.62598L8.64388 2.94597C8.53874 2.83529 8.41146 2.77995 8.27311 2.77995C8.13477 2.77995 8.00749 2.83529 7.90234 2.94597L4.22787 6.62598C4.12272 6.73665 4.07845 6.85287 4.07845 6.98568C4.07845 7.25684 4.27767 7.46712 4.55436 7.46712C4.68718 7.46712 4.81445 7.42285 4.903 7.33431L6.16471 6.09473L7.81934 4.27962L7.7806 5.45833L7.7806 12.7464C7.7806 13.0342 7.98535 13.2334 8.27311 13.2334Z"
        fill={fillColor}
      />
    </g>
  );
};

export const TableSortDirectionArrowAscSvg: React.FC<SvgProps> = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 16 16"
      {...(props.svg ?? {})}
    >
      <TableSortDirectionArrowAscGroup {...props} />
    </svg>
  );
};
